export default __webpack_public_path__ + "static/media/weight-loss_get-your-medication.74118791.jpg";